import { render, staticRenderFns } from "./TransitionCurtain.vue?vue&type=template&id=5b9ade15&scoped=true&"
import script from "./TransitionCurtain.vue?vue&type=script&lang=ts&"
export * from "./TransitionCurtain.vue?vue&type=script&lang=ts&"
import style0 from "./TransitionCurtain.vue?vue&type=style&index=0&id=5b9ade15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9ade15",
  null
  
)

export default component.exports